import React from 'react'
import {useParams} from "react-router";
import axios from "axios";
import {useNavigate} from "react-router-dom";
import AsyncBlock from "../../components/forms/AsyncBlock";
import {errorToast, successToast} from "../../components/layout/ToastStyles";
import {Apis} from "../../util/data";
import PageContainer from "../../components/layout/PageContainer";
import PageSection from "../../components/layout/PageSection";
import {PageBackLabel} from "../../components/layout/PageBackLabel";
import PageTitle from "../../components/layout/PageTitle";
import useFetch2 from "../../hooks/useFetch2";
import CategoriaForm from "./CategoriaForm";

const CategoriaEdit = () => {

  const navigate = useNavigate()

  const {id} = useParams()
  const {data, loading, fetchData, error} = useFetch2(Apis.PROD + '/categoria-producto/' + id, {});

  const onUpdate = (categoria) => {
    axios.put(Apis.PROD + '/categoria-producto/' + id, categoria)
      .then(res => {
        successToast("Categoria actualizada correctamente")
        navigate('/categoria')
      })
      .catch(err => {
        errorToast(err.response.data.message, 6000)
      });
  }

  return (
    <PageContainer>
      <PageSection>
        <PageBackLabel text='Categorias' onClick={() => navigate('/categoria')}/>
        <PageTitle title={data.categoria}/>
      </PageSection>

      <PageSection>
        <AsyncBlock loading={loading} error={error}>
          <CategoriaForm value={data} onSubmit={(cat) => onUpdate(cat)}/>
        </AsyncBlock>

      </PageSection>
    </PageContainer>
  )
}

export default CategoriaEdit;
